const Dns = require("./Dns").default;
const {DnsCollection} = require("./DnsCollection");
const {DnsItem} = require("./DnsItem");

module.exports.default = {
    Dns, DnsCollection, DnsItem
};